import { ComponentProps, useCallback } from 'react'
import { useNavigate } from 'react-router'
import { api } from 'src/api/root'
import SetNewPasswordTemplate from 'src/templates/auth/forgot-password/SetNewPasswordTemplate'
import { ROUTES } from 'src/types/routes'

export default function SetNewPasswordPage() {
  const navigate = useNavigate()
  const token = new URLSearchParams(window.location.search).get('token') as string
  const { mutateAsync, isLoading } = api.auth.resetPassword.useMutation()

  const handleSubmit: ComponentProps<typeof SetNewPasswordTemplate>['onSubmit'] = async ({
    password,
    confirmPassword,
  }) => {
    try {
      await mutateAsync({ token, password, confirmPassword })
      navigate(ROUTES.HOME)
    } catch (error) {
      // Ca;; toast (TODO)
      console.error('Reset password failed:', error)
    }
  }
  const goBack = useCallback(() => {
    navigate(ROUTES.SIGN_IN)
  }, [navigate])

  return <SetNewPasswordTemplate onSubmit={handleSubmit} isLoading={isLoading} goBack={goBack} />
}
